import Box from '@mui/joy/Box';
import Divider from "@mui/joy/Divider";
import Grid from "@mui/joy/Grid";
import Stack from '@mui/joy/Stack';
import Typography from "@mui/joy/Typography";

import './leaders.css'
import LeadershipCard from "../../components/LeadershipCard";
import Cliff from "../../assets/Cliff.jpg"
import Joshua from "../../assets/Joshua.jpg"
import Betsy from "../../assets/Besty.jpeg"
import Robbi from "../../assets/Robbi.jpeg"
import Brandy from "../../assets/Brandy.jpeg"
import Vince from "../../assets/Vince.jpeg"

const Leaders = () => {
    return (
        <Box className='App-header' sx={{backgroundColor: '#006494'}}>
                <Box className='pastor-container' sx={{backgroundColor: 'white'}}>
                <Stack direction='row' spacing={12} sx={{margin: 10, display: {md: 'flex', xs: 'none'}}}>
                    <Stack className='pastor-column' spacing={4}>
                        <Typography level='h1'>
                            Meet our Church Leadership
                        </Typography>
                        <Typography level='h4'>
                            Senior Pastor
                        </Typography>
                        <Typography level='body-md' >
                            Cliff King
                        </Typography>
                        <Typography level='body-md'>
                            Cliff has been aptly described by his friends as a “chainsaw looking for wood.” He would say he just has a huge appetite for life.  Whether it is in his pursuit of God, in loving his family, or even pushing himself in the sport of triathlon, giving less than his all is just not an option. “From an early age my dad ingrained in me the quote that ‘A job worth doing is worth doing well.’ When I gave my life to Jesus in college that translated into a desire to hear from my heavenly Father, ‘well done my good and faithful servant.’ That desire has not changed in over 35 years of ministry.”
                        </Typography>
                        <Stack direction='row' spacing={4}>
                            <Divider orientation="vertical"/>
                            <Typography>
                                ’When I gave my life to Jesus in college that translated into a desire to hear from my heavenly Father, ‘well done my good and faithful servant.’
                            </Typography>
                        </Stack>
                        <Typography level='body-md'>
                            As the Senior Pastor at NHV, Cliff’s goal has been to foster a community of people who catch that same vision of excellence and sacrifice for the sake of Jesus Christ. Cliff has used his unique teaching ability, alongside his coaching style of leadership, to motivate and equip others to live life at their highest potential. He has been married to Robbi, his wife and partner in ministry for 40 years, and they have three married children and nine grandchildren.
                        </Typography>
                    </Stack>
                    <Box className='pastor-column'>
                        <img className='pastor-image' src={Cliff} alt='Cliff King'/>
                    </Box>
                </Stack>
                <Stack direction='column' spacing={12} sx={{margin: 10, display: {md: 'none', xs: 'flex'}}}>
                    <Stack className='pastor-column' spacing={4}>
                        <Typography level='h1' textAlign='center'>
                            Meet our Church Leadership
                        </Typography>
                        <Typography level='h4'>
                            Senior Pastor
                        </Typography>
                        <Typography level='body-md' >
                            Cliff King
                        </Typography>
                        <Box className='pastor-column'>
                        <img className='small-pastor-image' src={Cliff} alt='Cliff King'/>
                        </Box>
                        <Typography level='body-md'>
                            Cliff has been aptly described by his friends as a “chainsaw looking for wood.” He would say he just has a huge appetite for life.  Whether it is in his pursuit of God, in loving his family, or even pushing himself in the sport of triathlon, giving less than his all is just not an option. “From an early age my dad ingrained in me the quote that ‘A job worth doing is worth doing well.’ When I gave my life to Jesus in college that translated into a desire to hear from my heavenly Father, ‘well done my good and faithful servant.’ That desire has not changed in over 35 years of ministry.”
                        </Typography>
                        <Stack direction='row' spacing={4}>
                            <Divider orientation="vertical"/>
                            <Typography>
                                ’When I gave my life to Jesus in college that translated into a desire to hear from my heavenly Father, ‘well done my good and faithful servant.’
                            </Typography>
                        </Stack>
                        <Typography level='body-md'>
                            As the Senior Pastor at NHV, Cliff’s goal has been to foster a community of people who catch that same vision of excellence and sacrifice for the sake of Jesus Christ. Cliff has used his unique teaching ability, alongside his coaching style of leadership, to motivate and equip others to live life at their highest potential. He has been married to Robbi, his wife and partner in ministry for 40 years, and they have three married children and nine grandchildren.
                        </Typography>
                    </Stack>
                </Stack>
                <Stack direction='row' spacing={12} sx={{margin: 10, display: {md: 'flex', xs: 'none'}}}>
                    <Stack className='pastor-column' spacing={4}>
                        <Typography level='h4' >
                            Associate Pastor
                        </Typography>
                        <Typography level='body-md' >
                            Joshua Ball
                        </Typography>
                        <Typography level='body-md'>
                            I’m deeply passionate about sharing the good news of God’s Kingdom and creating space for His presence to break into our lives in real and transformative ways. Nothing brings me more joy than equipping and encouraging others in their apprenticeship to Jesus, helping people grow in spiritual formation, discipleship, and the use of spiritual gifts. I love the Vineyard vision that “everyone gets to play” and believe that every follower of Jesus is invited to participate in the work of the Kingdom in naturally supernatural ways.
                        </Typography>
                        <Stack direction='row' spacing={2}>
                            <Divider orientation="vertical"/>
                            <Typography>
                                I carry a strong heart for hospitality and genuine connection. I long to see the local church become a place of healing, growth, and transformation, a vibrant family where people are known, loved, and empowered to live out their calling. Around here, there’s always room for one more at the table. Together, as a community, we seek to follow Jesus wholeheartedly, live out the Great Commission, and make disciples who bring hope and renewal to our city and beyond.
                            </Typography>
                        </Stack>
                        <Typography level='body-md'>
                           In my rhythms of rest and play, I love spending time with my beautiful Brazilian wife and our two precious daughters who light up my life. I also enjoy building deep friendships, laughing over a good meal, and hosting spaces where people can belong. You might also find me playing sports, exercising, strumming my guitar, or as Nacho Libre once said, “read some books!”
                        </Typography>
                    </Stack>
                    <Box className='pastor-column'>
                        <img className='pastor-image' src={Joshua} alt='Joshua Ball' />
                    </Box>
                </Stack>
                <Stack direction='row' spacing={12} sx={{margin: 10, display: {md: 'none', xs: 'flex'}}}>
                    <Stack className='pastor-column' spacing={4}>
                        <Typography level='h4' >
                            Associate Pastor
                        </Typography>
                        <Typography level='body-md' >
                            Joshua Ball
                        </Typography>
                        <Box className='pastor-column'>
                        <img className='small-pastor-image' src={Joshua} alt='Joshua Ball' />
                        </Box>
                        <Typography level='body-md'>
                            I’m deeply passionate about sharing the good news of God’s Kingdom and creating space for His presence to break into our lives in real and transformative ways. Nothing brings me more joy than equipping and encouraging others in their apprenticeship to Jesus, helping people grow in spiritual formation, discipleship, and the use of spiritual gifts. I love the Vineyard vision that “everyone gets to play” and believe that every follower of Jesus is invited to participate in the work of the Kingdom in naturally supernatural ways.
                        </Typography>
                        <Stack direction='row' spacing={2}>
                            <Divider orientation="vertical"/>
                            <Typography>
                                I carry a strong heart for hospitality and genuine connection. I long to see the local church become a place of healing, growth, and transformation, a vibrant family where people are known, loved, and empowered to live out their calling. Around here, there’s always room for one more at the table. Together, as a community, we seek to follow Jesus wholeheartedly, live out the Great Commission, and make disciples who bring hope and renewal to our city and beyond.
                            </Typography>
                        </Stack>
                        <Typography level='body-md'>
                           In my rhythms of rest and play, I love spending time with my beautiful Brazilian wife and our two precious daughters who light up my life. I also enjoy building deep friendships, laughing over a good meal, and hosting spaces where people can belong. You might also find me playing sports, exercising, strumming my guitar, or as Nacho Libre once said, “read some books!”
                        </Typography>
                    </Stack>
                    
                </Stack>

                <Typography level='h2' sx={{margin: 4}}>Meet our Elders</Typography>
                <Grid className='elder-container' container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{marginBottom: 4}}>
                    <Grid size={{ xs: 2, sm: 4, md: 4 }}>
                        <LeadershipCard
                            image={Robbi}
                            name='Robbi King'
                            title='Elder'
                        />
                    </Grid>
                    <Grid size={{ xs: 2, sm: 4, md: 4 }}>
                        <LeadershipCard
                            image={Vince}
                            name='Vince Saroni'
                            title='Elder'
                        />
                    </Grid>
                    <Grid size={{ xs: 2, sm: 4, md: 4 }}>
                        <LeadershipCard
                            image={Betsy}
                            name='Betsy Saroni'
                            title='Elder'
                        />
                    </Grid>
                    <Grid size={{ xs: 2, sm: 4, md: 4 }}>
                        <LeadershipCard
                            image={Brandy}
                            name='Brandy Stigler'
                            title='Elder'
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
        
    );
};

export default Leaders;